
              import "_sentry-debug-id-injection-stub";
              import * as OriginalModule from "./app/javascript/application.js";
              export default OriginalModule.default;
              export * from "./app/javascript/application.js";